import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "corporate-view" }
const _hoisted_2 = { class: "row g-0 red-color justify-content-center text-white mt-4 pt-5 pb-5" }
const _hoisted_3 = {
  class: "col-8 text-left",
  style: {"font-size":"1.15rem","line-height":"1.5"}
}
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "mb-5 fw-bold" }
const _hoisted_6 = { class: "agency-corporate-main-font-size" }
const _hoisted_7 = { class: "bg-black text-center text-white mt-4 pb-2 pt-3 fs-3" }
const _hoisted_8 = { class: "mb-0 pb-0 agency-signature-main" }
const _hoisted_9 = { class: "mb-0 pt-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.subTitle), 1),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content, (item) => {
            return (_openBlock(), _createElementBlock("p", {
              key: item,
              class: "mb-0"
            }, _toDisplayString(item), 1))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.signatureMain), 1),
      _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.websiteUrl), 1)
    ])
  ]))
}